import { ButtonV2, Contacts, Input, Logo } from '@shared/widgets';
import clsx from 'clsx';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { RoutePaths } from '@shared/utils';

export const ApplyNowPage = () => {
  const [code, setCode] = useState<string>('');

  return (
    <div className={clsx('flex min-h-screen w-full items-center justify-between bg-[#232323]', 'public-page animat-up')}>
      <div className='text-#929292 relative mx-auto flex h-screen w-full max-w-[330px] flex-col justify-center pt-10'>
        <div className='mx-auto mb-13'>
          <Logo width='210' height='28' />
        </div>
        <Input value={code} onChange={setCode} placeholder='CODE' className='animat-input mb-7' />
        <ButtonV2 className='animat-btn-in mb-7' disabled={code === ''}>
          APPLY
        </ButtonV2>
        <Link to={RoutePaths.login.onNavigate()}>
          <ButtonV2 className='animat-btn-in' fullWidth color='outlined'>
            CANCEL
          </ButtonV2>
        </Link>
        <div className='mt-8 w-full text-center text-xs font-medium text-white uppercase opacity-20'>
          <div>
            If you can’t remember your ICA password, please use the password retrieval process by filling in the form on the right. A message will be
            sent to your personal email address registered with your account with the login details.
            <br />
            <br />
            We strongly recommend that you change your password regularly for security enhancement.
          </div>
        </div>
        <Contacts className='animat-up-long mt-12 text-center text-sm font-medium text-white uppercase opacity-70' />
      </div>
    </div>
  );
};
